import React from 'react';
import { CircleStackIcon } from '@heroicons/react/24/solid';
import { useCredits } from '../../contexts/CreditsContext';

export default function CreditsBalance() {
  const { credits, isLoading } = useCredits();
  
  return (
    <div className="flex items-center space-x-2 text-gray-700">
      <CircleStackIcon className="h-5 w-5 text-indigo-500" />
      <span className="text-sm">Credits</span>
      <span className={`font-medium ${isLoading ? 'opacity-50' : ''}`}>
        {credits}
      </span>
    </div>
  );
}